if (!customElements.get('recently-viewed-products')) {
  const ProductCarouselElement = customElements.get('product-carousel-element');

  customElements.define('recently-viewed-products', class extends ProductCarouselElement {
    get sectionSelector() {
      return '.section-recently-viewed-products';
    }

    buildUrl() {
      if (!window.theme?.recentlyViewed) return null;

      const handles = window.theme.recentlyViewed.getHandles();
      const currentHandle = this.dataset.handle;
      const productsToShow = parseInt(this.dataset.productsToShow, 10) || 4;

      const filteredHandles = handles
        .filter(handle => !currentHandle || handle !== currentHandle)
        .slice(0, productsToShow);

      if (filteredHandles.length === 0) return null;

      const searchQuery = filteredHandles.map(handle => `handle:${handle}`).join(' OR ');
      return `${this.dataset.url}${encodeURIComponent(searchQuery)}`;
    }
  });
}
